module.exports = __webpack_public_path__ + "images/remove-quantity976649a2d34f670b3fb4d1b8d9cb7758.svg";